<template>
  <div>
    <Modal v-model="showModal" title="选择要添加到群组的用户" width="1000" @on-cancel="initSelected">
       <Alert show-icon>重复添加会使该用户角色更新</Alert>
      <Row style="width: 50%;display: inline-block;">
      <Select v-model="selectedUser" multiple filterable @on-change="memSelChange" placeholder="选择用户">
        <Option v-for="item in userList" :key="item.id" :value="item.id">
          <img v-if="item.avatar_url" width="10" height="10" :src="item.avatar_url">{{ item.name }}
        </Option>
      </Select>
      </Row>
      <Row style="width: 50%;display: inline-block;padding-left: 1%;">
        <Select v-model="selectedRole" placeholder="选择角色：" style="width: 73%;display: inline-block;margin-right: 1%;">
        <Option v-for="item in roleList" :key="item.id" :value="item.id">
          {{ item.dec }}
        </Option>
      </Select>
       <Button type="success"  @click="addGroupMember()" :disabled="disabledAddMember" style="width: 25%;display: inline-block;">添加到群组</Button>
      </Row>
      <Divider />
      <Divider />
      <div>
        <Form :model="memberSearchForm" ref="memberSearchForm" inline :label-width="40" @submit.native.prevent>
          <FormItem label="筛选">
            <Input v-model="memberSearchForm.name" style="width: 200px" placeholder="成员名称" @keyup.enter.native="getGroupMemberList()" />
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getGroupMemberList()">搜索</Button>
          </FormItem>
        </Form>
        <Table
          stripe
          border
          highlight-row
          ref="groupMemberTable"
          :data="members.data"
          :loading="tableLoading"
          :columns="members.columns"></Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ members.data.length }} 条记录，总共 {{ members.count }} 条记录
          </div>
          <div style="float: right;">
            <page
              :total="members.count"
              :current="members.page"
              :page-size="members.size"
              @on-change="getGroupMemberList"></page>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getAllUsers, getGroupUsers, addGroupMember, deleteGroupMember } from '@/api/tools/gitlab'
export default {
  name: 'GroupMember',
  props: ['groupId', 'node'],
  data () {
    return {
      tableLoading: false,
      disabledAddMember: true,
      memberSearchForm: {
        name: ''
      },
      roleList: [
        { id: 10, name: 'GUEST_ACCESS', dec: '访客' },
        { id: 20, name: 'REPORTER_ACCESS ', dec: '测试人员' },
        { id: 30, name: 'DEVELOPER_ACCESS ', dec: '开发人员' },
        { id: 40, name: 'MAINTAINER_ACCESS ', dec: '项目经理' },
        { id: 50, name: 'OWNER_ACCESS ', dec: '管理员' }
      ],
      selectedUser: [],
      selectedRole: null,
      showModal: false,
      userList: [],
      members: {
        data: [],
        columns: [
          {
            title: '成员名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 200
          },
          {
            title: '成员角色',
            key: 'access_level',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              return h('span', params.row.access_level ? this.roleList.filter(item => item.id === parseInt(params.row.access_level))[0].dec : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 200,
            render: (h, params) => {
              return h('div', [
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: this.$store.state.user.superuser && parseInt(params.row.access_level) !== 50 ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5
      }
    }
  },
  watch: {
    groupId () {
      this.getGroupMemberList()
    },
    node () {
      this.getUserList()
    }
  },
  methods: {
    delete (row) {
      let data = {
        userId: row.id,
        groupId: this.groupId,
        node: this.node
      }
      deleteGroupMember(data).then(res => {
        if (res.data.code === 200) {
          this.getGroupMemberList()
        } else {
          this.$Message.error('删除群组成员失败')
        }
      }).catch(res => {
        this.changeLoadingShow = false
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    initSelected () {
      this.selectedUser = []
      this.selectedRole = null
      this.memberSearchForm.name = ''
    },
    addGroupMember () {
      if (this.selectedRole) {
        let data = {
          userId: this.selectedUser,
          role: this.selectedRole,
          groupId: this.groupId,
          node: this.node
        }
        addGroupMember(data).then(res => {
          if (res.data.code === 200) {
            this.disabledAddMember = true
            this.initSelected()
            this.getGroupMemberList()
          } else {
            this.$Message.error('添加成员到群组失败')
          }
        }).catch(res => {
          this.changeLoadingShow = false
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({ title: '请选择用户角色' })
      }
    },
    memSelChange () {
      this.disabledAddMember = false
    },
    // 打开选择对话框
    openModal () {
      if (this.groupId) {
        this.getGroupMemberList()
      }
      if (this.node) {
        this.getUserList()
      }
      this.showModal = true
    },
    // 获取所有gitlab用户列表
    getUserList () {
      console.log('getUserList ' + this.node)
      let params = {
        node: this.node
      }
      getAllUsers(params).then(res => {
        this.userList = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // 获取群组用户列表
    getGroupMemberList (value = 1) {
      console.log('getGroupMemberList ' + this.node)
      this.tableLoading = true
      this.members.page = value
      let params = {
        group_id: this.groupId,
        name: this.memberSearchForm.name,
        size: this.members.size,
        page: this.members.page,
        node: this.node
      }
      getGroupUsers(params).then(res => {
        this.members.data = res.data.results
        this.members.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        console.log(res.response)
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
